import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const SUBTITLE_LABELS = {
  en: 'English',
  ko: '한국어',
  ja: '日本語',
  ru: 'Русский',
  it: 'Italiano',
  pt: 'Português',
  es: 'Español',
  fr: 'Français',
  zh: '中文',
  th: 'ไทย',
  vi: 'Tiếng Việt',
};

// Builds <track> descriptors from a { lang: url } map. All languages (including EN) are declared
// as tracks so they show up in the browser's native CC menu.
export const buildSubtitleTracks = (subtitlesMap) => {
  if (!subtitlesMap || typeof subtitlesMap !== 'object' || Array.isArray(subtitlesMap)) return [];
  return Object.entries(subtitlesMap)
    .filter(([, src]) => src && typeof src === 'string')
    .map(([lang, src]) => ({
      src: src.startsWith('/api/media/') ? `${BACKEND_URL}${src}` : src,
      lang,
      label: SUBTITLE_LABELS[lang] || lang.toUpperCase(),
    }));
};

// Polls a subtitle generation job until it finishes (status 'done' or 'error')
export const pollSubtitleJob = async (targetType, targetId, { intervalMs = 4000, timeoutMs = 600000 } = {}) => {
  const started = Date.now();
  while (Date.now() - started < timeoutMs) {
    await new Promise((resolve) => setTimeout(resolve, intervalMs));
    const res = await axios.get(
      `${BACKEND_URL}/api/admin/subtitle-jobs/${targetType}/${targetId}`,
      { withCredentials: true }
    );
    if (res.data.status === 'done' || res.data.status === 'error') {
      return res.data;
    }
  }
  throw new Error('Subtitle generation timed out');
};
